import { render, staticRenderFns } from "./SupplementCreate.vue?vue&type=template&id=6d783576&scoped=true&"
import script from "./SupplementCreate.vue?vue&type=script&lang=js&"
export * from "./SupplementCreate.vue?vue&type=script&lang=js&"
import style0 from "./SupplementCreate.vue?vue&type=style&index=0&id=6d783576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d783576",
  null
  
)

export default component.exports